import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import BarcodeScannerComponent from 'react-qr-barcode-scanner'

const CustomBarcodeScanner = ({
  headerText = null,
  stop = false,
  onRead = () => {},
  onError = () => {},
  width = '100%',
  height = 'auto',
  sx = { display: 'flex', flexDirecton: 'column', alignItems: 'center', position: 'relative' },
}) => {
  return (
    <Box className="barcodescanner" sx={{ position: 'relative', ...sx }}>
      {headerText ? (
        <Typography
          variant="h6"
          align="center"
          sx={{
            mb: 2,
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            background: 'var(--mui-palette-action-active)',
            zIndex: 1,
            color: 'white',
          }}
        >
          {headerText}
        </Typography>
      ) : null}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <BarcodeScannerComponent
          width={width}
          height={height}
          stopStream={stop}
          onError={onError}
          onUpdate={(err, result) => {
            if (result) {
              onRead(result.text)
            }
          }}
        />
      </Box>
    </Box>
  )
}

export default CustomBarcodeScanner
